import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import type { EventData } from '../../types'

export const reviewModel = ({
  reviewPosition,
  reviewPhotos = false,
  averageRate,
  relevanceScore,
  countryCode,
  isReviewFromCurrentCountry,
  isReviewTranslated,
  photosReviewsDisplayed,
  reviewComment,
  reviewSellerId,
  backboxGrade,
  reviewVoteCount,
  reviewId,
  helpRequestStatus,
}: EventData) => {
  return removeEmptyValuesInObject({
    review_position_impression: reviewPosition,
    review_with_photos: reviewPhotos,
    review_score_impression: averageRate,
    review_from_country: isReviewFromCurrentCountry,
    review_language: countryCode,
    review_translated: isReviewTranslated,
    photos_reviews_displayed: photosReviewsDisplayed,
    review_with_comment: reviewComment,
    review_seller_id: reviewSellerId,
    review_grade: backboxGrade,
    review_vote_count: reviewVoteCount,
    review_id: reviewId,
    help_request_status: helpRequestStatus,
    relevance_score: relevanceScore,
  })
}

export const globalRatingModel = ({ averageRate, count }: EventData) => {
  return removeEmptyValuesInObject({
    average_rate: averageRate,
    reviews_total_count: count,
  })
}
